import React, { useTranslation } from 'react-i18next';

import { DefaultLayout } from '../../components/DefaultLayout';
import { BigGreyHeading } from '../Recipes/pages/RecipeDetail/components/styles';
import { usePageTitle } from '../../hooks/usePageTitle';

const ImprintPage = () => {
  const { t } = useTranslation();

  usePageTitle(t('pageTitles.imprint'));

  return (
    <DefaultLayout withoutAnonymousUserNotice>
      <BigGreyHeading>{t('imprint.title')}</BigGreyHeading>
      <p>
        Alle Rechte vorbehalten. Text, Bilder, Grafiken, Sound, Animationen und
        Videos sowie deren Anordnung auf Websites und Web-Applikationen der RAPS
        GmbH & Co. KG unterliegen dem Schutz des Urheberrechts und anderer
        Schutzgesetze. Der Inhalt dieser Websites und Web-Applikationen darf
        nicht zu kommerziellen Zwecken kopiert, verbreitet, verändert oder
        Dritten zugänglich gemacht werden. Einige Websites und Web-Applikationen
        der RAPS GmbH & Co. KG enthalten außerdem Bilder, die dem Copyright
        Dritter unterliegen.
      </p>
      <h2>ANSCHRIFT</h2>
      <address>
        E-Mail: <a href="mailto:info@raps.com">info@raps.com</a>
      </address>
      <address>
        RAPS GmbH & Co. KG
        <br />
        Adalbert-Raps-Str. 1<br />
        95326 Kulmbach
        <br />
        Amtsgericht Bayreuth - HRA 978
        <br />
        Ust-IdNr.: DE 133085233
        <br />
        Steuer-Nr. 229/173/01607 - ILN 40 08679 00000 6
      </address>
      <address>
        RAPS Verwaltungs-GmbH
        <br />
        Adalbert-Raps-Str. 1<br />
        95326 Kulmbach
        <br />
        Amtsgericht Bayreuth - HRB 3292
        <br />
        Geschäftsführer: Dr. Oliver Ebneth
        <br />
      </address>
      <address>
        Kammerzugehörigkeit:
        <br />
        IHK für Oberfranken
        <br />
        Bahnhofstr. 23/27
        <br />
        95444 Bayreuth
        <br />
        <br />
        IHK-Nummer: 10035996
        <br />
        <br />
        Aufsichtsbehörde Regierung von Oberfranken, Bayreuth
        <br />
      </address>
      <h2>STREITSCHLICHTUNG</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{' '}
        <a href="https://ec.europa.eu/consumers/odr">
          https://ec.europa.eu/consumers/odr
        </a>
        .
      </p>
      <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
      <h2>HAFTUNG FÜR INHALTE</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
        diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8
        bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
        übermittelte oder gespeicherte fremde Informationen zu überwachen oder
        nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
        hinweisen.
      </p>
      <p>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
        Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.
      </p>
      <h2>HAFTUNG FÜR LINKS</h2>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar.
      </p>
      <p>
        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
        ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
        Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
        entfernen.
      </p>
      <h2>URHEBERRECHT</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
      </p>
      <p>
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
      </p>
    </DefaultLayout>
  );
};

export default ImprintPage;
